/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 1,
  scroll: 1,
});
jQuery("#nav2").slide({
  mainCell: ".img-group",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 3,
  scroll: 5,
});

new Swiper(".sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 4000,
  },

  loop: true,
});
new Swiper(".sp-swiper2", {
  speed: 5000,
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 1,
  },
  slidesPerView: 3,

  loop: true,
});
var thumbsp = new Swiper("#thumbs-p", {
  direction: "vertical",
  spaceBetween: 9,
  slidesPerView: 3,
  watchSlidesVisibility: true, //防止不可点击
});
let swiper = new Swiper("#swiper-p1", {
  thumbs: {
    swiper: thumbsp,
  },
  on: {
    slideChange: function (e) {
      $("#sp-color .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});

let spImgList = [
  // "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/8_e2970bb8-1497-4cfb-aa81-1944c514f6b8.png?v=1767524972",
  // "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/6_61eaeb09-84c9-4aee-b731-0d9e17863ee2.png?v=1767524972",
  // "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/9.png?v=1767524972",
  // "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/5_55d39676-f353-472d-95f9-792966ffd8ac.png?v=1767524972",
  // "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/7_7094b603-bccf-4167-8fd5-6d29b841a741.png?v=1767524971",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p1.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p2.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p3.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p4.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p5.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p1-s.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p2-s.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p3-s.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p4-s.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p5-s.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p1-l.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p2-l.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p3-l.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p4-l.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-p5-l.png",
];
let bannerList = [
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-img1.jpeg",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-img2.jpeg",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-b1.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-b2.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-b3.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-b4.png",
  "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20240724-b5.png",
];
function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            222 * $("div#root").css("zoom") -
            138 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let sp_price1 = 49.99;
let sp_price2 = 119.99;

function calcTotal(price, num) {
  let result = Number(price) * Number(num);
  return result.toFixed(2);
}

  let prods = window.product
  function getCur(){
    let color = $('#sp-color div.active').attr('data-val')
    let size = $('#sp-size div.active').attr('data-val')
    return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
  }

    function changePrice(){
    let num = $('#calcNumber').val()
    let price = (getCur().price * num / 100).toFixed(2)
    let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    console.log(off_font)
    $(".product-part .sp-uppercase .off-font").html(off_font);

  }

$(".sp-reduce").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) - 1;
  if (num > 0) {
    input.value = num;
  }
  // $("#sp_price1").html(calcTotal(sp_price1, input.value));
  // $("#sp_price2").html(calcTotal(sp_price2, input.value));
  changePrice()
});
$(".sp-add").click(function () {
  let input = $(this).siblings("input")[0];
  let num = Number(input.value) + 1;
  input.value = num;
  // $("#sp_price1").html(calcTotal(sp_price1, input.value));
  // $("#sp_price2").html(calcTotal(sp_price2, input.value));
  changePrice()
});

  $('.sp-btn-style').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

$(function () {
  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // style选项

    let colorOptions = $("#sp-color .option.active").index();
    let sizeOptions = $("#sp-size .option.active").index();

    if(sizeOptions === 0) {
      swiper.slideTo(colorOptions);
    } else if(sizeOptions === 1) {
      const targetIndex1 = colorOptions+5;
      // $(".sp-img-more1").show();
      swiper.slideTo(targetIndex1);
    }else if (sizeOptions === 2){
      const targetIndex = colorOptions+10;
      // $(".sp-img-more1").show();
      swiper.slideTo(targetIndex);
    // _swiper.slideToLoop(targetIndex);

    }
    changePrice()
  });

  // style选项
  // // 处理加入购物车事件
  // function handleAddToCart(num) {
  //   if (num > 0) {
  //     $("#cardNum").html(num).show();
  //     $(".sp-top-btn").addClass("sp-high");
  //     $(".sp-top-btn span").html("Check out");
  //     $(".sp-header-top .sp-cart").addClass("on");
  //   } else {
  //     $("#cardNum").html(0).hide();

  //     $(".sp-top-btn").removeClass("sp-high");
  //     $(".sp-top-btn span").html("Buy now");
  //     $(".sp-header-top .sp-cart").removeClass("on");
  //   }
  // }
  // handleAddToCart(0);

  $('.addCart').click(function () {
  var data = {
    id: getCur().id,
    quantity: $('#calcNumber').val(),
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
        $('#cardNum').html(result.item_count)
      })
    },
    dataType: 'json',
  })
})

  // 购物车加购动效
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });
  let initNum = 0;
  $(".product-part .cart-btn").click(function () {
    let spNum = $(".product-part #calcNumber")[0].value;
    initNum += Number(spNum);

    $("#calcNumber").val(1);
    // $("#cardNum").html(initNum);
    // handleAddToCart(initNum);
    let sizeOptions = $("#sp-size .option.active").index();

    // var img = $(".product-part .p-img");
    var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(".product-part").append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      background: "#e7e9ef",
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top:
          finish[0].offsetTop + finish.height() / 2 + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
    if (sizeOptions == 1) {
      var img2 = $(
        ".product-part .sp-swiper .swiper-slide-active .sp-img-more"
      );

      var flyer2 = img2[0].cloneNode(true);
      flyer2.classList.add("sp-clone2");
      $("#shopping").append(flyer2);
      $(".sp-clone2").css({
        width: img2[0].width,
        height: img2[0].height,
        position: "fixed",
        top: img2[0].offsetTop,
        left: img2.offset().left,
        "z-index": "99",
      });
      $(".sp-clone2").animate(
        {
          top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0
          );
        }
      );
    }
  });
});
